module.exports = "<div>\r\n    <button tabindex=\"0\" *ngIf=\"router.url === '/alerts'\" type=\"button\" (click)=\"update()\" class=\"btn btn-sm btn-outline-primary\">Acknowledge</button>\r\n    <button tabindex=\"0\" (keydown)=\"focus($event)\" type=\"button\" (click)=\"navigate()\" class=\"btn btn-sm btn-outline-primary\">Go to</button>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/acknowledge/acknowledge.component.html
// module id = ./src/app/acknowledge/acknowledge.component.html
// module chunks = main